import MacroStats from "./MacroStats";
import AnalysisAccordion from "./AnalysisAccordion";

export default function WeeklyAnalysis({ totals, numDates, strengths, deficits, recommendations, micros }) {
    return (
        <>
            <MacroStats totals={totals} numDates={numDates} />
            <AnalysisAccordion
                strengths={strengths}
                deficits={deficits}
                recommendations={recommendations}
                micros={micros}
                numDates={numDates}
            />
        </>
    );
}